import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _flagsInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/flags";
import { isEmpty, noop } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { EnrollmentWorkflow } from './components/EnrollmentWorkflow/EnrollmentWorkflow';
import { FacesheetProfile } from './components/FacesheetProfile';
import { getAdapter, setAdapters, setCallbacks, setHooks, setTrackEvent, setCoreUrl } from './config/api';
import { setGoogleMapsKey } from './config/services';
import AppProvider from './context/context';
function AppClientProfile(_ref) {
  var contact = _ref.contact,
    currentEmployee = _ref.currentEmployee,
    groupId = _ref.groupId,
    networkId = _ref.networkId,
    _ref$callbacks = _ref.callbacks,
    callbacks = _ref$callbacks === void 0 ? {} : _ref$callbacks,
    _ref$adapters = _ref.adapters,
    adapters = _ref$adapters === void 0 ? {} : _ref$adapters,
    _ref$hooks = _ref.hooks,
    hooks = _ref$hooks === void 0 ? {} : _ref$hooks,
    _ref$trackEvent = _ref.trackEvent,
    trackEvent = _ref$trackEvent === void 0 ? noop : _ref$trackEvent,
    flags = _flagsInstanceProperty(_ref),
    _ref$fieldsConfig = _ref.fieldsConfig,
    fieldsConfig = _ref$fieldsConfig === void 0 ? {} : _ref$fieldsConfig,
    constants = _ref.constants;
  var ncDisplayOnly = flags.ncDisplayOnly,
    hasEnrollmentWQ = flags['enrollment-wq'],
    limitedGenderOptions = flags.limitedGenderOptions,
    cl787SexualityFields = flags['cl-787-sexuality-fields'],
    clientIdStandardizationEnabled = flags.clientIdStandardizationEnabled,
    cl1018PreferredLanguage = flags['cl-1018-preferred-language'],
    hasSocialCareNavigation = flags.hasSocialCareNavigation;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    lastUpdates = _useState2[0],
    setLastUpdates = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    inEnrollMode = _useState4[0],
    setInEnrollMode = _useState4[1];
  var _useState5 = useState(undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    planId = _useState6[0],
    setPlanId = _useState6[1];
  var _useState7 = useState(undefined),
    _useState8 = _slicedToArray(_useState7, 2),
    primaryInsuranceId = _useState8[0],
    setPrimaryInsuranceId = _useState8[1];
  var fetchRecentUpdates = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(!isEmpty(contact) && ncDisplayOnly)) {
            _context.next = 6;
            break;
          }
          _context.next = 3;
          return getAdapter('legacyClient').get("people/".concat(contact.id, "/recent_updates"));
        case 3:
          response = _context.sent;
          setLastUpdates(response.data.data);
          return _context.abrupt("return", response);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [contact, ncDisplayOnly]);

  // Functions are being set as global, values are in the react context
  setAdapters(adapters);
  setCallbacks(_objectSpread(_objectSpread({}, callbacks), {}, {
    fetchRecentUpdates: fetchRecentUpdates
  }));
  setTrackEvent(trackEvent);
  setHooks(hooks);
  setCoreUrl(constants === null || constants === void 0 ? void 0 : constants.CORE_BASE_URL);
  setGoogleMapsKey(constants === null || constants === void 0 ? void 0 : constants.GOOGLE_MAPS_API_KEY);
  var goBackToFacesheet = function goBackToFacesheet() {
    setInEnrollMode(false);
    setPlanId(undefined);
    setPrimaryInsuranceId(undefined);
  };
  var goToEnrollmentWorkflow = function goToEnrollmentWorkflow(planId, primaryInsuranceId) {
    setInEnrollMode(true);
    setPlanId(planId);
    setPrimaryInsuranceId(primaryInsuranceId);
  };
  useEffect(function () {
    fetchRecentUpdates();
  }, [contact, fetchRecentUpdates]);
  if (!contact) return null;
  return /*#__PURE__*/React.createElement(AppProvider, {
    initialValue: {
      contact: contact,
      flags: flags,
      fieldsConfig: fieldsConfig
    }
  }, hasEnrollmentWQ && inEnrollMode && planId ? /*#__PURE__*/React.createElement(EnrollmentWorkflow, {
    contact: contact,
    planId: planId,
    primaryInsuranceId: primaryInsuranceId,
    groupId: groupId,
    currentEmployee: currentEmployee,
    goBackToFacesheet: goBackToFacesheet,
    fetchRecentUpdates: fetchRecentUpdates
  }) : /*#__PURE__*/React.createElement(FacesheetProfile, {
    contact: contact,
    goToEnrollmentWorkflow: goToEnrollmentWorkflow,
    groupId: groupId,
    lastUpdates: lastUpdates,
    networkId: networkId,
    shouldShowLastUpdate: ncDisplayOnly,
    shouldShowSexualityFields: cl787SexualityFields,
    shouldShowExternalIdentifiers: clientIdStandardizationEnabled,
    limitedGenderOptions: limitedGenderOptions,
    shouldShowPreferredLanguages: cl1018PreferredLanguage,
    shouldShowPopulationsAndConditions: hasSocialCareNavigation
  }));
}
AppClientProfile.propTypes = {
  contact: PropTypes.shape({
    id: PropTypes.string.isRequired,
    date_of_birth: PropTypes.number.isRequired,
    full_name: PropTypes.string.isRequired,
    has_military: PropTypes.bool.isRequired,
    household: PropTypes.object
  }).isRequired,
  currentEmployee: PropTypes.string.isRequired,
  groupId: PropTypes.string.isRequired,
  networkId: PropTypes.string.isRequired,
  callbacks: PropTypes.shape({
    toast: PropTypes.shape({
      success: PropTypes.func.isRequired,
      error: PropTypes.func.isRequired,
      warn: PropTypes.func
    }).isRequired
  }).isRequired,
  adapters: PropTypes.shape({
    coreApi: PropTypes.object.isRequired,
    coreApiClientBase: PropTypes.func.isRequired,
    legacyClient: PropTypes.func.isRequired
  }).isRequired,
  hooks: PropTypes.shape({
    useFind: PropTypes.func.isRequired,
    useFindRecord: PropTypes.func.isRequired,
    usePopulate: PropTypes.func.isRequired,
    usePopulateMemo: PropTypes.func.isRequired,
    useInvalidateQueries: PropTypes.func.isRequired,
    useCreateRecord: PropTypes.func.isRequired,
    useUpdateRecord: PropTypes.func.isRequired
  }).isRequired,
  trackEvent: PropTypes.func.isRequired,
  flags: PropTypes.shape({
    ncDisplayOnly: PropTypes.bool,
    'enrollment-wq': PropTypes.bool,
    'pays-2525-temp-scc-start-at': PropTypes.bool,
    isPaymentsUser: PropTypes.bool,
    'cl-787-sexuality-fields': PropTypes.bool,
    clientIdStandardizationEnabled: PropTypes.bool,
    'pays-3513-prevent-overlapping-scc-and-enrollment-requests': PropTypes.bool,
    'cl-1018-preferred-language': PropTypes.bool,
    hasSocialCareNavigation: PropTypes.bool
  }).isRequired,
  fieldsConfig: PropTypes.object,
  constants: PropTypes.object
};
export default AppClientProfile;
//# sourceMappingURL=App.js.map